(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-ilab-sales-product]').forEach(root => {
      if (root.dataset.ilabSalesReady) return;
      root.dataset.ilabSalesReady = 'true';
      const id = root.dataset.section;
      const form = document.getElementById(`product-form-${id}`);
      const mainButton = form?.querySelector('[name="add"]');
      const sticky = root.querySelector('[data-ilab-sticky]');
      const stickyButton = root.querySelector('[data-ilab-sticky-add]');
      const price = document.getElementById(`price-${id}`);
      const picker = root.querySelector('variant-radios,variant-selects');
      const variants = (() => { try { return JSON.parse(picker?.querySelector('script[type="application/json"]')?.textContent || '[]'); } catch { return []; } })();
      const dialog = root.querySelector('.ilab-sales-grade-dialog');
      let opener = null;
      const open = button => { if (!dialog) return; opener = button; dialog.showModal(); };
      root.addEventListener('click', event => { const button = event.target.closest('[data-ilab-grade-open]'); if (button) open(button); });
      dialog?.querySelector('[data-ilab-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
      dialog?.addEventListener('click', event => { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); });
      const sync = () => {
        if (!mainButton || !stickyButton) return;
        const disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
        stickyButton.disabled = disabled;
        stickyButton.textContent = mainButton.querySelector('span')?.textContent.trim() || mainButton.textContent.trim();
        const regular = price?.querySelector('.price__regular .price-item--regular');
        const sale = price?.querySelector('.price__sale .price-item--sale');
        const priceText = price?.querySelector('.price--on-sale') ? sale?.textContent : regular?.textContent;
        if (priceText) root.querySelector('[data-ilab-sticky-price]').textContent = priceText.trim();
        const chosenId = Number(form?.querySelector('[name="id"]')?.value);
        const chosen = variants.find(v => Number(v.id) === chosenId);
        if (chosen) root.querySelector('[data-ilab-sticky-label]').textContent = chosen.title === 'Default Title' ? '' : chosen.title;
        const stock = root.querySelector('[data-ilab-stock]');
        if (stock) { stock.textContent = root.querySelector(disabled ? '[data-ilab-unavailable]' : '[data-ilab-available]').textContent; stock.style.color = disabled ? '#626d7b' : '#27754d'; }
      };
      if (mainButton && sticky) {
        const observer = new IntersectionObserver(entries => { const entry = entries[0]; sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0; }, { threshold: 0 });
        observer.observe(mainButton);
        const mutation = new MutationObserver(sync);
        mutation.observe(mainButton, { attributes: true, childList: true, subtree: true });
        if (price) mutation.observe(price, { childList: true, subtree: true });
        stickyButton.addEventListener('click', () => { sync(); if (!stickyButton.disabled) mainButton.click(); });
      }
      root.addEventListener('change', event => {
        if (!picker?.contains(event.target)) return;
        const fieldsets = [...picker.querySelectorAll('fieldset')];
        const selects = [...picker.querySelectorAll('select')];
        const groups = fieldsets.length ? fieldsets : selects;
        const index = groups.findIndex(g => g === event.target || g.contains(event.target));
        if (index < 0) return;
        const choices = fieldsets.length ? fieldsets.map(g => g.querySelector('input:checked')?.value) : selects.map(g => g.value);
        if (!variants.some(v => v.available && v.options.every((o, i) => o === choices[i]))) {
          const candidates = variants.filter(v => v.available && v.options[index] === choices[index]);
          const score = v => v.options.reduce((n, o, i) => n + (i !== index && o === choices[i] ? 1 : 0), 0);
          candidates.sort((a, b) => score(b) - score(a) || a.price - b.price);
          const next = candidates[0];
          if (next) {
            groups.forEach((group, i) => { if (fieldsets.length) group.querySelectorAll('input').forEach(input => { input.checked = input.value === next.options[i]; }); else group.value = next.options[i]; });
            root.querySelector('[data-ilab-option-notice]').textContent = root.dataset.adjustedText;
          }
        }
      }, true);
      root.addEventListener('change', () => requestAnimationFrame(sync));
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
(() => {
  const initCollections = (scope = document) => {
    scope.querySelectorAll('[data-ilab-device-collection]').forEach(root => {
      if (root.dataset.ilabRefineReady) return;
      root.dataset.ilabRefineReady = 'true';
      const model = root.querySelector('[data-ilab-model]');
      const grade = root.querySelector('[data-ilab-grade]');
      const storage = root.querySelector('[data-ilab-storage]');
      if (!model || !grade || !storage) return;
      let cards = [];
      const fill = (select, values, label = value => value) => {
        const selected = select.value;
        const first = select.options[0].cloneNode(true);
        select.replaceChildren(first);
        [...new Set(values)].sort((a, b) => String(a).localeCompare(String(b), 'en-GB', { numeric: true })).forEach(value => select.add(new Option(label(value), value)));
        if ([...select.options].some(option => option.value === selected)) select.value = selected;
      };
      const gradeLabel = value => { const key = String(value).toLowerCase(); const text = ['a', 'b', 'c'].includes(key) ? root.querySelector(`[data-ilab-grade-${key}]`) : null; return text ? `${text.textContent} (${value})` : value; };
      const filter = () => {
        const params = new URLSearchParams(location.search);
        const min = Number(params.get('filter.v.price.gte') || 0) * 100;
        const max = params.get('filter.v.price.lte') ? Number(params.get('filter.v.price.lte')) * 100 : Infinity;
        let count = 0;
        for (const item of cards) {
          const matches = item.variants.filter(v => v.available && Number(v.price) >= min && Number(v.price) <= max && (!grade.value || v.options[item.gradeIndex] === grade.value) && (!storage.value || v.options[item.storageIndex] === storage.value));
          const show = (!model.value || item.card.dataset.model === model.value) && matches.length > 0;
          item.card.closest('.grid__item').hidden = !show;
          if (show) count++;
          if (show && matches.length) {
            const cheapest = matches.reduce((a, b) => Number(a.price) < Number(b.price) ? a : b);
            const price = item.card.querySelector('.ilab-sales-card__price');
            const from = document.createElement('small'); from.textContent = item.card.dataset.from;
            const text = new Intl.NumberFormat('en-GB', { style: 'currency', currency: root.dataset.currency || 'GBP' }).format(Number(cheapest.price) / 100);
            price.replaceChildren();
            if (from && matches.length > 1) price.append(from);
            price.append(document.createTextNode(text));
          }
        }
        root.querySelector('[data-ilab-count]').textContent = count;
        root.querySelector('[data-ilab-empty]').hidden = count !== 0;
        root.querySelector('[data-ilab-reset]').hidden = !model.value && !grade.value && !storage.value;
      };
      const refresh = () => {
        cards = [...root.querySelectorAll('[data-ilab-device-card]')].map(card => {
          let options = [], variants = [];
          try { options = JSON.parse(card.dataset.options).map(o => o.toLowerCase()); variants = JSON.parse(card.querySelector('[data-ilab-card-variants]').textContent); } catch {}
          return { card, variants, gradeIndex: options.findIndex(o => o === 'grade' || o === 'condition'), storageIndex: options.findIndex(o => ['storage', 'size', 'capacity'].includes(o)) };
        });
        fill(model, cards.map(item => item.card.dataset.model));
        fill(grade, cards.flatMap(item => item.variants.map(v => v.options[item.gradeIndex]).filter(Boolean)), gradeLabel);
        fill(storage, cards.flatMap(item => item.variants.map(v => v.options[item.storageIndex]).filter(Boolean)));
        grade.disabled = grade.options.length === 1;
        storage.disabled = storage.options.length === 1;
        filter();
      };
      [model, grade, storage].forEach(select => select.addEventListener('change', filter));
      root.querySelector('[data-ilab-reset]').addEventListener('click', () => { model.value = ''; grade.value = ''; storage.value = ''; filter(); });
      const container = root.querySelector('#ProductGridContainer');
      if (container) new MutationObserver(refresh).observe(container, { childList: true });
      refresh();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCollections()); else initCollections();
  document.addEventListener('shopify:section:load', event => initCollections(event.target));
})();
